import { useMemo } from 'react';
import { useStorage } from '@/js/libs/hooks/useStorage/index.ts';
import { useCallbackRef } from '../../hooks/useCallbackRef/index.js';
import { StorageKey } from '../types.js';
const useTokenStorage = () => {
    const { loadString, saveString, removeItem } = useStorage({ storage: window.localStorage });
    const forgetAuthToken = useCallbackRef(() => removeItem(StorageKey.TOKEN));
    const getAuthToken = useCallbackRef(() => loadString(StorageKey.TOKEN));
    const storeAuthToken = useCallbackRef((token) => saveString(StorageKey.TOKEN, token));
    return useMemo(() => ({
        forgetAuthToken,
        getAuthToken,
        storeAuthToken,
    }), [forgetAuthToken, getAuthToken, storeAuthToken]);
};
export default useTokenStorage;
